const SET_VIN_IDENTIFICATION_DATA = (state, data) => {
  state.vinIdentificationData = data;
};

const SET_VEHICLE_MILEAGE = (state, payload) => {
  state.mileage = payload;
};

const SET_HSN_TSN_DATA = (state, payload) => {
  state.hsnTsnData = payload;
};

const SET_ENGAGE_CUSTOMER = (state, payload) => {
  state.engageCustomer = payload;
};

const SET_ENGAGE_VEHICLE = (state, payload) => {
  state.engageVehicle = payload;
};

const SET_PREV_ROUTES = (state, payload) => {
  // keep array of previous routes for back button to use
  // otherwise it would go back to conversation which is avoided with this
  if (state.prevRoutes.indexOf(payload) !== -1) {
    state.prevRoutes = state.prevRoutes.slice(0, state.prevRoutes.indexOf(payload) + 1);
  } else if (payload && payload !== 'conversation') {
    state.prevRoutes.push(payload);
  }
};

export default {
  SET_VIN_IDENTIFICATION_DATA,
  SET_VEHICLE_MILEAGE,
  SET_HSN_TSN_DATA,
  SET_PREV_ROUTES,
  SET_ENGAGE_CUSTOMER,
  SET_ENGAGE_VEHICLE
}
